/* ComBank compliance: Terms & Conditions checkout gate.
   Moved out of snippets/cart-drawer.liquid (where it only loaded when cart
   type = "drawer") into this standalone asset, loaded with defer from
   layout/theme.liquid, so the gate works for every cart type.
   - Checkout buttons ship with the `disabled` attribute in markup and are
     only enabled once a terms checkbox is ticked.
   - All terms checkboxes are kept in sync (drawer + /cart page).
   - Express/dynamic checkout buttons are locked with `inert` so they are
     unreachable by keyboard and pointer until terms are accepted. */
(function () {
  function setTermsState(accepted) {
    document.querySelectorAll('.js-terms-agree').forEach(function (cb) {
      cb.checked = accepted;
      var btn = document.getElementById(cb.dataset.checkout);
      if (btn) btn.disabled = !accepted;
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (dyn) {
      dyn.classList.toggle('is-terms-locked', !accepted);
      if (accepted) {
        dyn.removeAttribute('inert');
      } else {
        dyn.setAttribute('inert', '');
      }
    });
  }

  function syncTermsState() {
    var boxes = document.querySelectorAll('.js-terms-agree');
    if (!boxes.length) return;
    var accepted = Array.prototype.some.call(boxes, function (cb) { return cb.checked; });
    setTermsState(accepted);
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (cb && cb.classList && cb.classList.contains('js-terms-agree')) {
      setTermsState(cb.checked);
    }
  });

  // Initial sync (also covers browsers restoring a previously ticked box).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTermsState);
  } else {
    syncTermsState();
  }
  // Re-sync when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncTermsState();
  });
})();
